"use strict";

const elements = [".textboxR", ".textboxL", ".textboxD"];

elements.forEach((element) => {
  gsap.from(element, {
    scrollTrigger: element,
    x: element.includes("R") ? 500 : element.includes("L") ? -500 : 0,
    y: element.includes("D") ? 500 : 0,
    opacity: 0,
    duration: 1.5,
    ease: "back.out(2)",
  });
});
gsap.from(
  ".imagez",
  {
    scrollTrigger: ".textboxD-images",
    y: 200,
    duration: 1,
    opacity: 0,
    stagger: 0.25,
    ease: "back.out(4)",
  }
);

const modals = document.querySelectorAll(".modalmain");
const overlay = document.querySelector(".overlay");
const btnsOpenModal = document.querySelectorAll(".footer-links, .welcome");
const btnsCloseModal = document.querySelectorAll(".close-modal, .overlay");

const openModal = (e) => {
  e.preventDefault();
  const x = e.target.dataset.label;
  const modalx = document.querySelector(".modal-" + x);
  modalx.classList.remove("hidden");
  overlay.classList.remove("hidden");
};

const closeModal = () => {
  modals.forEach((modal) => modal.classList.add("hidden"));
  overlay.classList.add("hidden");
};

btnsOpenModal.forEach((btn) => btn.addEventListener("click", openModal));
btnsCloseModal.forEach((btn) => btn.addEventListener("click", closeModal));

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") closeModal();
});